import { AcessoCbo } from 'graphql/types.generated'
import { Permission } from 'types/Permissions'

import useSession from './useSession'
import { isCboPermission, isPermission } from './useSessionUtils'

interface CheckPermissionProps {
  permission: Permission | AcessoCbo[]
}

const CheckPermission = (props) => {
  const { hasAuthorization, hasCboAuth } = useSession({ fetchPolicy: 'cache-only' })

  if (
    (isPermission(props.permission) && hasAuthorization(props.permission)) ||
    (isCboPermission(props.permission) && hasCboAuth(props.permission))
  ) {
    return props.children
  }

  return null
}

export default CheckPermission
